// @flow
import React from 'react'
import MainTemplate from 'components/templates/MainTemplate'
import SearchList from 'containers/pages/SearchPage/List'
import SearchMap from 'containers/pages/SearchPage/Map'
import FavoriteSelectModal from 'containers/organisms/FavoriteSelectModal'
import { imagePath } from 'frontend_core/dist/helpers/image'

export default props => (
  <MainTemplate
    title={i18n.t('server.www.search.title')}
    description={i18n.t('server.www.search.description')}
    image={imagePath('www/common/ogimage.png')}
    linkCanonical={props.linkCanonical}
    linkPrev={props.linkPrev}
    linkNext={props.linkNext}
    config={props.config}
    data={props.data}
    {...props}
  >
    {props.isShowMap ? (
      <SearchMap
        rooms={props.rooms}
        pageInfo={props.pageInfo}
        searchSessionId={props.searchSessionId}
        isLoading={props.isLoading}
      />
    ) : (
      <SearchList
        onClickFavorite={props.onClickFavorite}
        amenities={props.amenities}
        sponsoredPromotions={props.sponsoredPromotions}
        eventTypes={props.eventTypes}
        capacities={props.capacities}
        rooms={props.rooms}
        pageInfo={props.pageInfo}
        perPage={props.perPage}
        searchSessionId={props.searchSessionId}
        history={props.history}
        isLoading={props.isLoading}
        viewr={props.data.viewer}
        roomDetail={props.roomDetail}
        sponsoredPromotions={props.sponsoredPromotions}
      />
    )}
    {props.ui.isOpenFavoriteSelectModal && (
      <FavoriteSelectModal
        roomId={props.ui.room.id}
        roomUid={props.ui.room.uid}
        currentUser={props.data.viewer}
      />
    )}
  </MainTemplate>
)



// WEBPACK FOOTER //
// ./src/components/pages/SearchPage/index.jsx